import {axiosBlobRequest, axiosRequest} from "./apiBase";
import {UserProfile} from "../common/models/userProfile/userProfile.model";
import {PagedResult} from "../common/models/pagedResult";
import {UserProfilePublic} from "../common/models/userProfile/userProfilePublic.model";
import {SignUpSSOProfile} from "../common/models/userProfile/signUpSSOProfile.model";
import {BlobResponse} from "../common/interfaces/blobResponse";

export const userProfileCreate = async (profile: UserProfile): Promise<UserProfile> => {
    return axiosRequest(
        "POST",
        `userProfile`,
        profile
    )
}

export const userProfileCreateFromSSO = async (profile: SignUpSSOProfile, state: string, nonce: string): Promise<UserProfile> => {
    return axiosRequest(
        "POST",
        `userProfile/createFromSSO?state=${state}&nonce=${nonce}`,
        profile
    )
}

export const userProfileGetById = async (): Promise<UserProfile> => {
    return axiosRequest(
        "GET",
        `userProfile`,
    )
}

export const userProfileGetByUrlPath = async (url: string): Promise<UserProfilePublic> => {
    return axiosRequest(
        "GET",
        `userProfile/byUrlPath?url=${url}`,
    )
}

export const userProfileGetByDisplayName = async (name: string): Promise<PagedResult<UserProfile>> => {
    return axiosRequest(
        "GET",
        `userProfile/displayname?name=${name}`,
    )
}

export const userProfileGetPersonaImage = async (): Promise<BlobResponse> => {
    return axiosBlobRequest(
        "GET",
        `userProfile/getPersonaImage`,
        null,
        { responseType: "blob"}
    )
}

export const checkUrlAvailability = async (term: string): Promise<boolean> => {
    return axiosRequest(
        "GET",
        `userProfile/checkUrlAvailability?term=${term}`,
    )
}

export const userProfileSearch = async (term: string, page: number, pageSize: number): Promise<PagedResult<UserProfile>> => {
    return axiosRequest(
        "GET",
        `userProfile/search?term=${term}&page=${page}&pageSize=${pageSize}`,
    )
    
    /// EG usages in a screen
    // const onSearch = useDebounce(async (term: string) => {
    //     let results: UserProfile[] = [];
    //
    //     if (term) {
    //         const response = await userProfileSearch(term, 1, 10);
    //         results = response.results;
    //     }
    //
    //     setSearchResults(results);
    // }, 200);
}

export const userProfileUpdate = async (profile: UserProfile): Promise<UserProfile> => {
    return axiosRequest(
        "PUT",
        `UserProfile`,
        profile
    )
}